import type { PaidPlan } from '@/types/billing-plan';

export const SUBSCRIPTION_PRICES: Record<PaidPlan, { monthly: number; yearly: number }> = {
  team: { monthly: 40, yearly: 360 },
  pro: { monthly: 99, yearly: 950 },
  max: { monthly: 200, yearly: 1920 },
};
export const MONTHS_PER_YEAR = 12;
